import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import DataChip from '../../chip/DataChip';

export default class ChipCard extends React.Component {
  constructor(props) {
    super(props);
    this.chipClick = this.chipClick.bind(this);
  };
  chipClick(data, type) {
      this.props.chipClick(data,type);
  }

  render(){
    let triggerChips = [];
    if(typeof this.props.data !== 'undefined'){
      triggerChips = this.props.data.map( (val, key) => {
        return <DataChip key={key} value={val} chipClick={this.chipClick} tagType={this.props.type}/>
      });
    }
    return (
      <Box>
        <Typography variant="h6" gutterBottom>
          {this.props.title}
        </Typography>
          {(triggerChips.length > 0)?triggerChips:"None"}
      </Box>
    );
  }
}
